import React, { useEffect, useState } from 'react'
import './index.less'
import TabsPlusUI from '@/componentsUI/TabsPlusUI/TabsPlusUI'
import TabsPlusButtonUI from '@/componentsUI/TabsPlusUI/TabsPlusButtonUI/TabsPlusButtonUI'
import AmountPath from '../../assets/bg_mimiqian.webp'
import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus'
import LoadingUI from '@/componentsUI/LoadingUI/LoadingUI'
import {dealAmount0Fiexd, dealAmount2Fiexd, dealAmount4Fixed} from '@/Core/utils/currencyDealCenter'

const UserListItem = ({
    userId,
    amount,
    className,
    isFriend
}) => {

    const {t} = useTranslationPlus()

    return (<div className={`user-list-item ${className}`}>
        <div className='bg'></div>
        <div className='item-content'>
        <span className='userid'>{userId}</span>
        {!isFriend &&<span>{t('shareFriendWheel.text-15')}</span>}
        <div className='amount-div'>
            <img src={AmountPath}></img>
            <span>+{amount}</span>
        </div>

        </div>

    </div>)
}

function generateRandomString() {
    const firstDigit = Math.floor(Math.random() * 10);

    const lastTwoDigit = Math.floor(Math.random() * 90 + 10);

    return `${firstDigit}****${lastTwoDigit}`
}

const UserList = ({
    className = '',
    isLogin,
    dataList,
    friendsList = []
}) => {

    const [tableIndex,setTableIndex] = useState(0)

    const [datas , setDatas] = useState([]);

    const {t} = useTranslationPlus()

    useEffect(()=>{
        if(dataList?.length && isLogin) {
            setDatas([...dataList])
        }else {
            const arr =[]
            for(let i = 0 ; i < 16 ; ++i) {
                arr.push({
                    userId: generateRandomString(),
                    amount: 1000
                })
            }
            setDatas([...arr])
        }
    },[dataList,isLogin])

    return (
        <div className='wheel-user-list-content'>

            {isLogin && <TabsPlusUI
                defaultValue={0}
                onSelect={(index) => {
                    setTableIndex(index)
                }}
            >
                <TabsPlusButtonUI
                    type={'link-6'}
                    index={0}
                    title={t('shareFriendWheel.text-5')}
                />
                <TabsPlusButtonUI
                    type={'link-6'}
                    index={1}
                    title={t('shareFriendWheel.text-6')}
                />
            </TabsPlusUI>}
            <div className={`wheel-user-list ${className} ${tableIndex ? `wheel-table-1` : ``}`}>

                {
                    tableIndex === 1 && <div className='invite-content'>
                        {

                                !!friendsList.length ?
                                friendsList.map((v, index) => {
                                    return <UserListItem
                                    key={index}
                                    userId={v?.validUserId}
                                    amount={v.currencyType ? dealAmount4Fixed(v.amount,{
                                        currencyType: v.currencyType
                                    })  : v.amount}
                                    isFriend={true}
                                    className={`item${(index) % 2}`}
                                    />
                                }) : <LoadingUI isLoading={false} dataList={[]} style={{
                                    minHeight: 150
                                }}></LoadingUI>
                        }
                    </div>
                }
                {
                    tableIndex === 0 && <div className='container'>
                    <div className='inner'>
                        <div className='content'>
                            {
                         datas.map((v, index) => {
                            return <UserListItem
                            key={index}
                            userId={v.userId}
                            amount={v.currencyType ? dealAmount4Fixed(v.amount,{
                                currencyType: v.currencyType
                            })  : v.amount}
                            isFriend={false}
                            className={`item${index % 2}`}
                            />
                        })
                            }
                        </div>
                        <div className='content'>
                            {
                                datas.map((v, index) => {
                                    return <UserListItem
                                    key={index}
                                    userId={v.userId}
                                    isFriend={false}
                                    amount={v.currencyType ? dealAmount4Fixed(v.amount,{
                                        currencyType: v.currencyType
                                    })  : v.amount}
                                    className={`item${(index) % 2}`}
                                    />
                                })
                            }
                        </div>
                    </div>
                    <div className='blur-top'></div>
                    <div className='blur-bottom'></div>
                </div>
                }

            </div>
        </div>

    )
}


export default UserList
